// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader___lH2o","loaderOuter":"PageOverlayLoader_loaderOuter__1mvLt"};